import React, { useEffect, useRef } from "react";

import phoneFox from "../../assets/3xpng/PhoneFox.png";
import questioningFox from "../../assets/3xpng/QuestioningFox.png";
import { brand } from "../../branding/generated/brand-manifest";
import { assistantMark } from "../../constant";
import BrandedRasterIcon from "../reusableComponent/brandedRasterIcon/BrandedRasterIcon";
import { NudgeAction, NudgeImage } from "../../services/intent/types";
import AppButton from "../reusableComponent/button/button";
import styles from "./SlideInPanel.module.scss";

interface SlideInPanelProps {
  nudge: NudgeAction;
  onDismiss: () => void;
  onCta: () => void;
}

const AUTO_DISMISS_MS = 8000;

const IMAGE_MAP: Record<NudgeImage, string> = {
  questioning: questioningFox,
  phone: phoneFox,
};

// The fox poses are Zenvoya's mascot; a tenant brand shows its own mark instead.
const resolveFox = (image: NudgeImage | undefined): string =>
  brand.tenant !== "zenvoya" ? assistantMark : (image && IMAGE_MAP[image]) || questioningFox;

const SlideInPanel: React.FC<SlideInPanelProps> = ({ nudge, onDismiss, onCta }) => {
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    timerRef.current = setTimeout(onDismiss, AUTO_DISMISS_MS);
    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, [onDismiss]);

  const clearTimer = (): void => {
    if (timerRef.current) clearTimeout(timerRef.current);
  };

  const handleCtaClick = (): void => {
    clearTimer();
    onCta();
  };

  const handleDismiss = (): void => {
    clearTimer();
    onDismiss();
  };

  return (
    <div className={styles.overlay}>
      <div className={styles.panel}>
        <div className={styles.header}>
          <BrandedRasterIcon className={styles.icon} src={resolveFox(nudge.image)} alt="Zoya" usePartnerIcon />
          <div className={styles.text}>{nudge.text}</div>
        </div>
        <div className={styles.actions}>
          {nudge.cta?.label && (
            <AppButton variant="default" size="sm" onClick={handleCtaClick} className={styles.cta}>
              {nudge.cta.label}
            </AppButton>
          )}
          <AppButton variant="secondary" size="sm" onClick={handleDismiss} className={styles.cta}>
            Dismiss
          </AppButton>
        </div>
        <div className={styles.progressBar}>
          <div className={styles.progressFill} />
        </div>
      </div>
    </div>
  );
};

export default SlideInPanel;
